"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SuccessIcon = _interopRequireDefault(require("../SuccessIcon"));
var _Button = _interopRequireDefault(require("../Button"));
var OrderCancellationPopup = function OrderCancellationPopup(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$success = props.success,
    success = _props$success === void 0 ? false : _props$success,
    _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    _props$description = props.description,
    description = _props$description === void 0 ? '' : _props$description,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$buttons = props.buttons,
    buttons = _props$buttons === void 0 ? {} : _props$buttons;
  var primary = buttons.primary,
    secondary = buttons.secondary;
  var hasHeader = Boolean(header);
  var hasDescription = Boolean(description);
  var primaryVisible = Boolean(primary.visible);
  var secondaryVisible = Boolean(secondary.visible);
  var hasPrimaryLink = Boolean(primary.link);
  var hasSecondaryLink = Boolean(secondary.link);
  var primaryBtnComponent = /*#__PURE__*/_react["default"].createElement(StyledPrimaryButton, {
    onClick: primary.onClick
  }, primary.label);
  var secondaryBtnComponent = /*#__PURE__*/_react["default"].createElement(StyledSecondaryButton, {
    isMobile: isMobile,
    onClick: secondary.onClick
  }, secondary.label);
  var primaryBtn = hasPrimaryLink ? /*#__PURE__*/_react["default"].createElement("a", {
    href: primary.link
  }, primaryBtnComponent) : primaryBtnComponent;
  var secondaryBtn = hasSecondaryLink ? /*#__PURE__*/_react["default"].createElement("a", {
    href: secondary.link
  }, secondaryBtnComponent) : secondaryBtnComponent;
  return /*#__PURE__*/_react["default"].createElement(StyledOrderCancellationPopup, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    success: success
  }), hasHeader ? /*#__PURE__*/_react["default"].createElement(StyledHeader, null, header) : null, hasDescription ? /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description) : null, /*#__PURE__*/_react["default"].createElement(StyledButtonWrapper, {
    isMobile: isMobile
  }, primaryVisible ? primaryBtn : null, secondaryVisible ? secondaryBtn : null));
};
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationPopup__StyledHeader",
  componentId: "sc-1nz5umb-0"
})(["margin-top:16px;font-weight:500;font-size:22px;line-height:26px;color:#17181a;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationPopup__StyledDescription",
  componentId: "sc-1nz5umb-1"
})(["margin-top:8px;font-size:14px;color:#4d4d4d;text-align:center;"]);
var StyledPrimaryButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "OrderCancellationPopup__StyledPrimaryButton",
  componentId: "sc-1nz5umb-2"
})(["border:1px solid #007aff;border-radius:2px;margin-top:16px;background:#fff;width:max-content;"]);
var StyledSecondaryButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "OrderCancellationPopup__StyledSecondaryButton",
  componentId: "sc-1nz5umb-3"
})(["border:none;margin-top:", " ", " background:#fff;width:200px;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return "".concat(isMobile ? 4 : 16, "px;");
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return "".concat(isMobile ? '' : 'margin-left: 4px;');
});
var StyledButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationPopup__StyledButtonWrapper",
  componentId: "sc-1nz5umb-4"
})(["display:flex;flex-direction:", ";"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return "".concat(isMobile ? 'column' : 'row');
});
var StyledOrderCancellationPopup = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellationPopup__StyledOrderCancellationPopup",
  componentId: "sc-1nz5umb-5"
})(["", " background:#fff;padding:32px 16px;display:flex;flex-direction:column;align-items:center;filter:drop-shadow(0px 4px 4px rgba(0,0,0,0.25)) drop-shadow(0px 10px 15px rgba(216,214,204,0.9));border-radius:4px;"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return "".concat(isMobile ? 'width: 320px;' : 'width: 800px;');
});
var _default = exports["default"] = OrderCancellationPopup;